/**
 * @generated SignedSource<<5134c412a3cd61052f9801aeba8eef1a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckIsPostiesPage$data = {
  readonly urlAlias: string;
  readonly " $fragmentType": "helpersCheckIsPostiesPage";
};
export type helpersCheckIsPostiesPage$key = {
  readonly " $data"?: helpersCheckIsPostiesPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsPostiesPage">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckIsPostiesPage"
};

(node as any).hash = "01a5d88fadd47aa20dac78b1424a0c87";

export default node;
